import React, {useEffect, useState} from 'react';
import PropTypes from 'prop-types';
import styled, {css} from 'styled-components';

import {Button, Input} from '@drivesally/sally-ui';
import {darkGrey} from '@drivesally/sally-ui/lib/libs/colors';

const Wrapper = styled.div`
  align-items: ${({wrap}) => (wrap ? 'flex-start' : 'center')};
  display: flex;
  gap: 6px;
  max-width: 100%;
  min-width: 0;
  overflow: ${({wrap}) => (wrap ? 'visible' : 'hidden')};
`;

const TitleText = styled.span`
  flex: 1;
  min-width: 0;

  ${({wrap}) =>
    wrap
      ? css`
          overflow-wrap: anywhere;
          white-space: normal;
          word-break: break-word;
        `
      : css`
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        `};
`;

const Placeholder = styled(TitleText)`
  color: ${darkGrey};
`;

const InputWrapper = styled.div`
  flex: 1;
  min-width: 0;
`;

const ButtonWrapper = styled.div`
  flex-shrink: 0;
`;

const CrmTicketTitleEditor = ({title, saving, wrap, onSave}) => {
  const [editing, setEditing] = useState(false);
  const [value, setValue] = useState(title || '');

  useEffect(() => {
    if (!editing) setValue(title || '');
  }, [title, editing]);

  const stop = (e) => e.stopPropagation();

  const startEdit = (e) => {
    stop(e);
    setValue(title || '');
    setEditing(true);
  };

  const apply = async (e) => {
    stop(e);
    const next = value.trim();
    if (next === (title || '').trim()) {
      setEditing(false);
      return;
    }
    await onSave(next);
    setEditing(false);
  };

  if (editing) {
    return (
      <Wrapper wrap={wrap} onClick={stop}>
        <InputWrapper>
          <Input
            value={value}
            onChange={setValue}
            disabled={saving}
            placeholder="Enter title"
            size="small"
            autoFocus
          />
        </InputWrapper>
        <ButtonWrapper>
          <Button size="tiny" onClick={apply} loading={saving}>
            Apply
          </Button>
        </ButtonWrapper>
      </Wrapper>
    );
  }

  return (
    <Wrapper wrap={wrap}>
      {title ? (
        <TitleText wrap={wrap} title={title}>
          {title}
        </TitleText>
      ) : (
        <Placeholder wrap={wrap}>Edit Title ...</Placeholder>
      )}
      <ButtonWrapper>
        <Button size="tiny" theme="grey" icon="edit" onClick={startEdit} />
      </ButtonWrapper>
    </Wrapper>
  );
};

CrmTicketTitleEditor.propTypes = {
  title: PropTypes.string,
  saving: PropTypes.bool,
  wrap: PropTypes.bool,
  onSave: PropTypes.func.isRequired,
};

CrmTicketTitleEditor.defaultProps = {
  title: '',
  saving: false,
  wrap: false,
};

export default CrmTicketTitleEditor;
